var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.06 5.05333L6.66671 9.44667L4.27337 7.06L3.33337 8L6.66671 11.3333L12 6L11.06 5.05333ZM8.00004 1.33333C4.32004 1.33333 1.33337 4.32 1.33337 8C1.33337 11.68 4.32004 14.6667 8.00004 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 4.32 11.68 1.33333 8.00004 1.33333ZM8.00004 13.3333C5.05337 13.3333 2.66671 10.9467 2.66671 8C2.66671 5.05333 5.05337 2.66667 8.00004 2.66667C10.9467 2.66667 13.3334 5.05333 13.3334 8C13.3334 10.9467 10.9467 13.3333 8.00004 13.3333Z",
    fill: "#5DCF41",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolved);
export default __webpack_public_path__ + "static/media/solved.d6d10012f4982fc4aee7bb56de1259d5.svg";
export { ForwardRef as ReactComponent };